/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import {AuthUser} from "../../contexts/auth_types";
import Footer from '../footer/Footer';
import SideBar from '../sidebar/SideBar';
import {TreeNode} from "../tree/Tree";

interface ISkeletonProps {
    children?: any;
    accounts: any;
    renovationsWorkflow: Array<TreeNode>|undefined;
    isPayrollAvailableForCurrentUser: boolean | undefined;
    user: AuthUser | null;
    /**
     * @description This function expects an `onNextClick` funtion to move through the accounts and operations pages on the footer.
     */
    onNextClick: () => void;

    /**
    * @description This function expects an `onPreviousClick` funtion to move through the accounts and operations pages on the footer.
    */
    onPreviousClick: () => void;
    hideFooter?: boolean;
}

function Skeleton(props: ISkeletonProps) {
    const {
        accounts,
        renovationsWorkflow,
        isPayrollAvailableForCurrentUser,
        children,
        onNextClick,
        onPreviousClick,
        hideFooter,
        user,
    } = props;

    return (
        <React.Fragment>
            { accounts && renovationsWorkflow && isPayrollAvailableForCurrentUser !== undefined &&
                <SideBar
                    renovationsWorkflow={renovationsWorkflow}
                    isPayrollAvailableForCurrentUser={isPayrollAvailableForCurrentUser}
                    user={user}
                />
            }

            {children}

            { !hideFooter &&
                    <Footer backText='Previous' nextText='Next' needGoBack={onPreviousClick} needGoNext={onNextClick} />
            }
        </React.Fragment>
    );
}

export default Skeleton;
